export const priceCustomFilter = (searchResults, priceSelected) => {
  return searchResults
    .map(clusterObj => {
      const newOptions = clusterObj.combinations
        .map(combination => {
          const nextLegOptions = combination.next_leg_options?.filter(
            nextOption =>
              nextOption.cluster.composition_price.total <= priceSelected
          );
          if (nextLegOptions?.length > 0) {
            return { ...combination, next_leg_options: nextLegOptions };
          }
          return null;
        })
        .filter(Boolean);

      return { ...clusterObj, combinations: newOptions };
    })
    .filter(clusterObj => clusterObj.combinations.length > 0);
};
